import { render, staticRenderFns } from "./ContirmDialog.vue?vue&type=template&id=1d313444&scoped=true"
import script from "./ContirmDialog.vue?vue&type=script&lang=js"
export * from "./ContirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ContirmDialog.vue?vue&type=style&index=0&id=1d313444&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d313444",
  null
  
)

export default component.exports